import { ReactNode } from "react";
import { cx } from "utils";
import { useUser } from "routes/dataroutes/UserData";


interface LoadingCardProps {
  isLoading: boolean;
  children: ReactNode;
}

export default function LoadingCard({ isLoading, children }: LoadingCardProps) {
  const user = useUser();
  const showLoadingState = isLoading && !user?.isBlocked;

  return (
    <div
      className={ cx(
        "h-full transition-all duration-300",
        showLoadingState && "blur-sm opacity-50 pointer-events-none"
      ) }
    >
      {children}
    </div>
  );
}
